<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsSelect v-model="type" :options="typeOptions"
                            :label="$LANG.Get('labels.customerType') + ':'"></NevsSelect>
                <NevsTextField v-if="type === 'company'" v-model="name" :error="validation.name"
                               :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
                <NevsTextField v-if="type === 'person'" v-model="first_name" :error="validation.first_name"
                               :label="'*' + $LANG.Get('fields.firstName') + ':'"></NevsTextField>
                <NevsTextField v-if="type === 'person'" v-model="last_name" :error="validation.last_name"
                               :label="'*' + $LANG.Get('fields.lastName') + ':'"></NevsTextField>
                <NevsTextField v-model="oib" :error="validation.oib"
                               :label="$LANG.Get('fields.oib') + ':'"></NevsTextField>
                <NevsCheckbox v-model="foreign" :label="$LANG.Get('fields.foreignClient')"></NevsCheckbox>
                <NevsTextField v-if="foreign" v-model="oib_label" :error="validation.oib_label"
                               :label="$LANG.Get('fields.oibLabel') + ':'"></NevsTextField>
                <NevsTextField v-model="email.address" :error="validation.email"
                               :label="$LANG.Get('fields.email') + ':'"></NevsTextField>
                <NevsCheckbox v-model="email.documents" :label="$LANG.Get('fields.emailDocuments')"></NevsCheckbox>
                <NevsTextArea v-model="address.address"
                              :label="$LANG.Get('fields.streetAndHouseNo') + ':'"></NevsTextArea>
                <NevsTextField v-model="address.postal_code"
                               :label="$LANG.Get('fields.postalCode') + ':'"></NevsTextField>
                <NevsTextField v-model="address.city"
                               :label="$LANG.Get('fields.city') + ':'"></NevsTextField>
                <NevsTextField v-model="address.country"
                               :label="$LANG.Get('fields.country') + ':'"></NevsTextField>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-times"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="saveClick()">
                    <i class="fa-solid fa-floppy-disk"></i>
                    {{ $LANG.Get('buttons.save') }}
                </NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "ModalAddCustomer",
    components: {NevsCheckbox, NevsTextArea, NevsTextField, NevsSelect, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            type: 'company',
            name: '',
            first_name: '',
            last_name: '',
            oib: '',
            foreign: false,
            oib_label: 'OIB',
            email: {
                address: '',
                documents: true
            },
            address: {
                address: '',
                postal_code: '',
                city: '',
                country: ''
            },
            validation: {
                name: '',
                first_name: '',
                last_name: '',
                oib: '',
                oib_label: '',
                email: ''
            }
        }
    },
    computed: {
        typeOptions() {
            return [
                {label: this.$LANG.Get('labels.company'), value: 'company'},
                {label: this.$LANG.Get('labels.person'), value: 'person'}
            ];
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.type = 'company';
            this.name = '';
            this.first_name = '';
            this.last_name = '';
            this.oib = '';
            this.foreign = false;
            this.oib_label = 'OIB';
            this.email = {address: '', documents: true};
            this.address = {address: '', postal_code: '', city: '', country: ''};
            this.validation = {name: '', first_name: '', last_name: '', oib: '', oib_label: '', email: ''};
            if (this.show) {
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        saveClick() {
            let valid = true;

            if (this.type === 'company') {
                if (this.name === '') {
                    valid = false;
                    this.validation.name = this.$LANG.Get('labels.mandatoryField');
                } else {
                    this.validation.name = '';
                }
            } else {
                if (this.first_name === '') {
                    valid = false;
                    this.validation.first_name = this.$LANG.Get('labels.mandatoryField');
                } else {
                    this.validation.first_name = '';
                }
                if (this.last_name === '') {
                    valid = false;
                    this.validation.last_name = this.$LANG.Get('labels.mandatoryField');
                } else {
                    this.validation.last_name = '';
                }
            }

            if (this.oib !== '') {
                if (!this.foreign) {
                    if (!this.$HELPERS.CheckOIB(this.oib)) {
                        valid = false;
                        this.validation.oib = this.$LANG.Get('labels.invalidOIB');
                    } else {
                        this.validation.oib = '';
                    }
                } else {
                    this.validation.oib = '';
                }
            } else {
                this.validation.oib = '';
            }

            if (this.foreign && this.oib_label === '') {
                valid = false;
                this.validation.oib_label = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.oib_label = '';
            }

            if (this.email.address !== '' && !this.$HELPERS.CheckEmail(this.email.address)) {
                valid = false;
                this.validation.email = this.$LANG.Get('labels.invalidEmailAddress');
            } else {
                this.validation.email = '';
            }

            if (!valid) return;

            let vm = this;
            let service = this.type === 'company' ? 'companies' : 'persons';
            let emails = this.email.address !== '' ? [{address: this.email.address, documents: this.email.documents}] : [];
            let body = {
                oib: this.oib,
                foreign: this.foreign,
                oib_label: this.oib_label,
                emails: emails,
                addresses: [{
                    address: this.address.address,
                    postal_code: this.address.postal_code,
                    city: this.address.city,
                    country: this.address.country,
                    official: true
                }],
                phones: [],
                active: true
            };

            if (this.type === 'company') {
                body.name = this.name;
            } else {
                body.first_name = this.first_name;
                body.last_name = this.last_name;
            }

            this.$API.APICall('post', service, body, (data, success) => {
                if (success) {
                    vm.$CROSS_TAB_BUS.TriggerEvent('reload-data', {});
                    vm.$emit('done', data.customer_id);
                } else {
                    if (data.error === 'oib_duplicate') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.oibDuplicate'),
                            type: 'alert'
                        });
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.nevs-popup {
    max-width: 500px;
    max-height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
}

.popup-form {
    padding: 10px;
    overflow-y: auto;
    flex: 1;
}

.popup-form h3 {
    margin: 10px 0 5px;
}
</style>
